// 引入分类游戏页，游戏详情页
import { wrapper } from '@/store';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

import { getMenuServerSideProps, MenuPageDetail } from "@/components/MenuPageDetail/index.js";
import { getGamePageServerSideProps, GameDetailPage } from "@/components/GamePage/index.js";

export default function GameSlugDetailPage(args) {
    // 所有hooks必须在条件判断之前调用
    const router = useRouter();
    const path = router.query.slug;
    const { menuData } = useSelector((state) => state.game);
    
    // 判断是否为菜单路径
    const isMenuPath = menuData.some((data) => data.path === path);
    
    // 根据路径类型渲染不同组件
    if (isMenuPath) {
        return <MenuPageDetail {...args} />;
    }
    
    return <GameDetailPage {...args} />;
}

// 添加服务端数据预取
export const getServerSideProps = wrapper.getServerSideProps(
    (store) => async (context) => {
        const { slug } = context.params;
        
        // 获取当前store状态中的menuData
        const state = store.getState();
        const { menuData } = state.game;

        if (menuData.some((data) => data.path === slug)) {
            return getMenuServerSideProps(context);
        } else {
            return getGamePageServerSideProps(context);
        }
    }
); 